<template>
  <div>
    <b-form class="b-layout" @submit.prevent="">
      <div class="fields">
        <div>
          <label>{{$t('title')}}</label>
          <b-input class="input-pentagro" v-model="title"></b-input>
        </div>
        <div>
          <label
            >{{$t('desiredValue')}}
            {{ attrSelected.key ? `(${attrSelected.key})` : "" }}</label
          >
          <b-input class="input-pentagro" v-model="value" step="0.1" type="number"></b-input>
        </div>

        <!-- BOTÕES -->
        <b-button-group class="m-2">
          <b-button
            @click="select(0)"
            :class="{ 'btn-success': buttonSelected.current }"
          >
            {{$t('currents')}}
          </b-button>
          <b-button
            @click="select(1)"
            :class="{ 'btn-success': buttonSelected.operation }"
          >
            {{$t('operations')}}
          </b-button>
        </b-button-group>
        <!-- /BOTÕES -->

        <!-- CORRENTE -->
        <div v-if="buttonSelected.current" class="pt-2">
          <label for="select-current">{{$t('selectACurrent')}}</label>
          <select
            id="select-current"
            class="form-control"
            @change="changeCurrent()"
            v-model="form.current"
          >
            <option value="" selected>{{$t('chooseACurrent')}}</option>
            <option
              v-for="(current, index) in currents"
              :key="`node-current-${index}`"
              :value="current"
            >
              {{ current }}
            </option>
          </select>

          <div v-if="form.current" class="pt-2">
            <select
              id="select-properties"
              class="form-control"
              @change="changeCurrentProperties()"
              v-model="form.prop"
            >
              <option value="" selected>{{$t('chooseAProperty')}}</option>
              <option
                v-for="(prop, index) in currentProperties"
                :key="`node-prop-${index}`"
                :value="prop"
              >
                {{ prop.name }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="false">
          <label for="select-component">{{$t('selectAComponent')}}</label>
        </div>
        <!--/CORRENTE -->

        <!-- OPERATIONS -->
        <div v-if="buttonSelected.operation" class="pt-2">
          <label for="select-operation">{{$t('operations')}}</label>
          <select
            class="form-control"
            id="select-operation"
            @change="changeOperation()"
            v-model="form.operation"
          >
            <option value="" selected>{{$t('chooseAOperation')}}</option>
            <option
              v-for="(operation, index) in operations"
              :key="index"
              :value="operation"
            >
              {{ operation }}
            </option>
          </select>
        </div>
        <!-- /OPERATIONS -->

        <!-- ATRIBUTOS -->
        <div v-if="form.prop || form.operation" class="pt-2 node-attr">
          <b-form-select
            id="select-attr"
            class="form-control input-pentagro"
            v-model="attrSelected"
          >
            <b-form-select-option value="" selected
              >{{$t('chooseAAtribute')}}</b-form-select-option
            >
            <span></span>
            <b-form-select-option
              class="input-pentagro"
              v-for="([key, value], index) in attrsMap.entries()"
              :key="index"
              :value="value"
            >
              {{ `${key}: ${formatNumber(value.value)}` }}
            </b-form-select-option>
          </b-form-select>
          <b-icon
            class="btn-icon"
            icon="plus-circle-fill"
            @click="addAttr()"
            aria-hidden="true"
          />
        </div>
        <!-- /ATRIBUTOS -->
      </div>
      <div class="pl-4 pr-2">
        <table v-if="tableAttr.length > 0" class="table table-sm">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">{{$t('element')}}</th>
              <th scope="col">{{$t('currentTableAttribute')}}</th>
              <th scope="col">{{$t('currentTableProperty')}}</th>
              <th scope="col">{{$t('currentTableValue')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(attr, i) in tableAttr" :key="i">
              <th>
                <b-icon
                  class="btn-icon"
                  icon="dash-circle-fill"
                  @click="removeAttr(i)"
                />
              </th>
              <td>{{ attr.element }}</td>
              <td>{{ attr.attr }}</td>
              <td>{{ attr.name }}</td>
              <td>{{ attr.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { NumberFormat, ParseToNumber } from "../../utils/tools";
import { showError } from "@/global";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      formatNumber: NumberFormat,
      value: 0,
      title: this.node.title,
      currents: SingletonEnginnering.currents,
      operations: SingletonEnginnering.operations,
      buttonSelected: { current: false, operation: false },
      currentProperties: "",
      attrsSelected: "",
      attrSelected: "",
      attrsMap: null,
      form: {
        current: "",
        operation: "",
        prop: "",
        title: "",
        titleWidth: 0,
        titleHeight: 0,
        titleFontSize: 0,
      },
      tableAttr: new Array(),
    };
  },

  watch: {
    value() {
      if (this.node.attrs) {
        this.node.attrs.forEach((a) => {
          a.value = this.value;
        });
      }
      this.node.data.forEach((a) => {
        a.value = this.value;
      });
      if (this.tableAttr) {
        this.tableAttr.forEach((a) => {
          a.value = this.value;
        });
      }
    },
    title() {
      this.node.title = this.title;
    },
  },

  methods: {
    select(indice) {
      Object.keys(this.buttonSelected).forEach((show, i) => {
        this.buttonSelected[show] = i == indice;
      });
      this.form.current = "";
      this.form.operation = "";
      this.form.prop = "";
    },

    changeCurrent() {
      let props = SingletonEnginnering.getCurrentProperties(this.form.current);
      this.currentProperties = props;
      this.form.prop = "";
      this.node.dataType = "Correntes";
    },

    changeCurrentProperties() {
      let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(
        this.form.current,
        this.form.prop
      );
      this.attrsSelected = attrs;
      this.attrsMap = new Map();
      attrs.forEach((e) => this.attrsMap.set(e.key, e));
    },

    changeOperation() {
      let attrs = SingletonEnginnering.getOperationsProperties(
        this.form.operation
      );
      this.attrsSelected = attrs;
      this.attrsMap = new Map();
      attrs.forEach((e) => this.attrsMap.set(e.key, e));
      this.node.dataType = "Operações";
    },

    loadNode() {
      if (!this.node.dataType) return;

      this.tableAttr = new Array();
      this.node.data.forEach((a) => {
        this.tableAttr.push(this.getLineTable(a));
      });

      this.value = ParseToNumber(this.node.data[0].value);
    },

    getLineTable(prop) {
      return {
        propertie: prop,
        element: prop.index,
        attr: prop.propName ? prop.propName : prop.type,
        name: prop.key,
        value: prop.value,
      };
    },

    addAttr() {
      let hasAttr = this.tableAttr.find((a) =>
        a.propertie.isEquals(this.attrSelected)
      );

      if (this.attrSelected && !hasAttr) {
        this.tableAttr.push(this.getLineTable(this.attrSelected));
        this.node.attrs = this.tableAttr.map((a) => a.propertie);
      } else {
        showError(this.$t('essa-corrente-ja-foi-adicionada'));
      }
    },

    removeAttr(index) {
      let remove = this.tableAttr[index];
      this.tableAttr = this.tableAttr.filter(
        (l) => l.propertie.id != remove.propertie.id
      );
      this.node.attrs = this.tableAttr.map((a) => a.propertie);
    },
  },

  mounted() {
    this.loadNode();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.fields {
  min-width: 350px;
}

.b-layout {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.node-attr {
  display: flex;
  align-items: center;
}

table .btn-icon {
  font-size: 17px;
  cursor: pointer;
}

.node-attr > .btn-icon {
  font-size: 25px;
  margin-left: 10px;
  cursor: pointer;
}

.attr-unit {
  width: 50px;
}
</style>
